<script lang="ts">
  import { get, Readable, derived } from "svelte/store";
  import Window from "../components/Window.svelte";
  import { FileMgr } from "../stores/FileMgr";
  import DirView from "../test/DirView.svelte";
  import type { Theme, WinCbs, WinProps } from "../scripts/WinTypes";

  import Path from "../scripts/Path";
  import { onMount } from "svelte";
  import FinderIcon from "../components/FinderIcon.svelte";
  import { addLog, addWarn } from "../stores/LoggerStore";
  import { randomId } from "../scripts/utils";
  import type { Node, Dir, File } from "../scripts/FileTypes";
  import ProcMgr from "../stores/ProcMgr";
  import SettingsMgr from "../stores/SettingsMgr";
  export let winProps: WinProps;
  let closeWindow;
  const callbacks: WinCbs = {
    closeWindow: (func) => {
      closeWindow = func;
      return true;
    },
  };

  let finderElem: HTMLElement, backBtn: HTMLElement, forwardBtn: HTMLElement;
  winProps.name = winProps.name || "Finder";
  const filemgr = FileMgr.getInstance();

  //Theme ============================================================
  const _theme = SettingsMgr.getInstance().theme;
  const themeWatcher = (theme: Theme) => {
    if (!finderElem) {
      return;
    }
    const c = theme.colors;
    finderElem.style.setProperty("color", c["1"]);
    finderElem.style.setProperty("background-color", c["2"]);
    return theme.colors;
  };
  $: _colors = themeWatcher($_theme);

  let pathList: string[] = [];
  let pathCursor = 0;
  let currentPath = winProps.data.path;
  const updateBrowserButtons = () => {
    if (pathCursor === 1) {
      // disableBack();
      (backBtn as any).disabled = true;
    } else {
      addLog("Enable backbtn");
      (backBtn as any).disabled = false;
    }

    if (pathCursor === pathList.length) {
      // disableForward();
      (forwardBtn as any).disabled = true;
    } else {
      // enableBack();
      // enableForward();
      addLog("Enable forward btn");
      (forwardBtn as any).disabled = false;
    }
  };

  const onIconClick = (node: Node) => {
    if (node.type === "dir") {
      const dirPath = node.path.path;
      _dir = _setDir(dirPath);

      pathList = [...pathList.slice(0, pathCursor), dirPath];
      pathCursor = pathList.length;
      currentPath = dirPath;
      updateBrowserButtons();
      return;
    }
    ProcMgr.getInstance().exeFile(node.path);
  };
  const _browse = (backwards: boolean) => {
    const condition = backwards
      ? () => pathCursor === 1
      : () => pathCursor === pathList.length;
    if (condition()) {
      return;
    }
    pathCursor = pathCursor + (backwards ? -1 : 1);
    currentPath = pathList[pathCursor - 1];
    _dir = _setDir(currentPath);
    updateBrowserButtons();
  };
  const browseBack = () => {
    _browse(true);
  };
  const browseForward = () => {
    _browse(false);
  };

  const _setDir = (dirPath: string) => {
    const dir = filemgr.findDirReadable(new Path(dirPath));
    if (!dir) {
      addWarn("no dir");
      closeWindow?.();
    }
    return dir;
  };
  const fileMgrWatcher = (dir) => {
    // addWarn("finder change dir");
    const _dir = filemgr.findDirReadable(new Path(currentPath));
    if (!_dir) {
      addWarn("no dir");
      closeWindow?.();
    }
    return _dir;
  };
  let totalDir = filemgr.dirs;
  $: _dir = fileMgrWatcher($totalDir);
  $: nodes = derived(_dir, (dir: Dir) => {
    if (dir) {
      return <(Dir | File)[]>[...dir.dirs, ...dir.files];
    }
    return [];
  });

  const menuId = randomId();
  const closeFinderAction = (e) => {
    e.preventDefault();
    document.querySelector(`#${menuId}`)?.remove();
  };
  const openFinderAction = (e) => {
    if (document.querySelector(`#${menuId}`)) {
      return;
    }
    const menuElem = document.createElement("span") as HTMLElement;
    menuElem.id = menuId;
    menuElem.innerText = `Properties
    Create Directory
    Add Zip file here (...)
    To be updated
    `;
    menuElem.style.backgroundColor = "#333";
    menuElem.style.opacity = "0.9";
    menuElem.style.color = "#dbdbdb";
    menuElem.style.lineHeight = "1.8rem";
    menuElem.style.padding = "10px";
    menuElem.style.width = "160px";
    menuElem.style.height = "210px";
    menuElem.style.position = "fixed";
    menuElem.style.left = `${e.pageX}px`;
    menuElem.style.top = `${e.pageY}px`;
    menuElem.style.cursor = "pointer";
    menuElem.addEventListener("focusout", (_e) => {
      const thisElem = _e.target as HTMLElement;
      console.log("focus out");
      thisElem.parentElement.removeChild(thisElem);
    });
    menuElem.removeEventListener;
    finderElem.appendChild(menuElem);
    addLog("Right clicked");
  };

  function handleMouseBrowse(e) {
    e.preventDefault();
    if (typeof e === "object") {
      switch (e.button) {
        case 3:
          browseBack();
          break;
        case 4:
          browseForward();
          break;
      }
    }
  }

  onMount(() => {
    // console.log("Finder mounted");
    // console.log(winProps);
    // console.log(_dir);
    // finderElem?.addEventListener("click", handleFileAction);
    window.oncontextmenu = () => false;
    finderElem?.addEventListener("mouseup", handleMouseBrowse);
    finderElem?.addEventListener("mousedown", closeFinderAction);
    finderElem?.addEventListener("contextmenu", openFinderAction);

    // initialize
    _dir = _setDir(winProps.data.path);
    pathList = [winProps.data.path];
    pathCursor = 1;
    currentPath = winProps.data.path;
    updateBrowserButtons();
  });

  const backBtnClicked = () => {};
  const forwardBtnClicked = () => {};
</script>

<Window {winProps} {callbacks}>
  <div class="container" bind:this={finderElem}>
    <div class="browser">
      <button
        class="browser-content button back"
        on:click={browseBack}
        bind:this={backBtn}>&larr;</button
      >
      <button
        class="browser-content button forward"
        on:click={browseForward}
        bind:this={forwardBtn}>&rarr;</button
      >
      <span class="browser-content path">{currentPath}</span>
    </div>
    <div class="icon-container">
      <!-- <DirView dir={$_dir} /> -->
      {#each $nodes as node (node.node.id)}
        <!-- Nodes : {node.node.path.path}, type : {node.node.type} -->
        <FinderIcon fileNode={node.node} {onIconClick} />
      {/each}
    </div>
  </div>
</Window>

<style>
  .container {
    /* position: relative; */
    width: 100%;
    height: 100%;
  }
  .browser {
    display: flex;
    width: 100%;
    height: 40px;
    /* border-bottom: 1px solid #333; */
    box-sizing: border-box;
    align-items: center;
    box-shadow: 0px 0px 2px #333;
  }
  .browser-content {
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: none;
  }
  .browser-content.button {
    width: 50px;
    cursor: pointer;
    font-size: 1.5rem;
    color: #000;
    transition: 0.1s;
    height: 100%;
  }
  .browser-content.button:disabled {
    color: #888;
    cursor: not-allowed;
  }
  .browser-content.button:hover {
    background-color: #333;
    color: #dbdbdb;
  }

  .browser-content.button:disabled:hover {
    color: #888;
    background-color: transparent;
  }

  .browser-content.path {
    width: calc(100% - 100px);
    resize: none;
    margin-left: 10px;
  }
  .icon-container {
    margin: 0;
    box-sizing: border-box;
    display: grid;
    /* height: 100%; */
    height: calc(100% - 40px);
    width: 100%;
    padding: 5px;
    gap: 15px;
    grid-auto-flow: row;
    grid-template-columns: repeat(auto-fill, 120px);
    grid-template-rows: repeat(auto-fill, 140px); /* Your number of rows */
    /* direction: rtl; */
  }
</style>
